module.exports = "<div class=\"feed-data\">\r\n    <dm-header></dm-header>\r\n    <div class=\"tools-header\">\r\n        <span class=\"feed-title\">{{title}}</span>\r\n    </div>\r\n    <div class=\"feed-grid-wrapper\">\r\n        <feed-grid [allowExport]=\"true\" \r\n                [pagerLocation]=\"pagerLocation\">\r\n        </feed-grid>\r\n    </div>\r\n    <dm-footer></dm-footer>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/feeds/feed/feed.component.html
// module id = ./src/app/main/feeds/feed/feed.component.html
// module chunks = main